import { render, staticRenderFns } from "./browseBackIssues.vue?vue&type=template&id=9240af10&scoped=true"
import script from "./browseBackIssues.vue?vue&type=script&lang=js"
export * from "./browseBackIssues.vue?vue&type=script&lang=js"
import style0 from "./browseBackIssues.vue?vue&type=style&index=0&id=9240af10&prod&lang=scss"
import style1 from "./browseBackIssues.vue?vue&type=style&index=1&id=9240af10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9240af10",
  null
  
)

export default component.exports